import getName from '../../../../helpers/getName';
import { dspxDiffDays } from '../../../../helpers/dspx-utils';

const activeStatuses = new Set([1, 2]);

export const generateWorkers = (request, map, key) => {
  const worker = request[key];
  const id = worker?.id || 0;
  const rating = Number(request.rating);
  const hasActiveStatus = activeStatuses.has(request.statusId);
  const done = request.doneDate || hasActiveStatus;

  const entity = map.get(id) || {
    id,
    name: worker ? getName(worker) : 'Не указан',
    value: 0,
    speciality: worker?.speciality,
    rating: 0,
    ratingCount: 0,
    lifetime: 0,
    doneCount: 0,
  };

  entity.value += 1;

  if (!isNaN(rating)) {
    entity.rating += rating;
    entity.ratingCount += 1;
  }

  if (done) {
    entity.lifetime += dspxDiffDays(
      hasActiveStatus ? 0 : request.doneDate,
      request.createDateTime
    );

    entity.doneCount += 1;
  }

  map.set(id, entity);
};
